"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPublicRadio = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../../common");
const account_1 = require("../../../../base/account");
const react_redux_1 = require("react-redux");
exports.SetPublicRadio = react_1.default.memo(({ isDisable = false, defaultPublic, handlerChange, }) => {
    const isManager = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManager)(state));
    const PUBLIC_RADIO_LIST = [
        { id: 'open', title: 'conference.public', checked: false },
        { id: 'hide', title: 'conference.private', checked: true },
        ...(isManager
            ? [{ id: 'open_partial', title: 'conference.part', checked: false }]
            : []),
    ];
    const [list, setList] = react_1.default.useState(PUBLIC_RADIO_LIST);
    const [selectedId, setSelectedId] = react_1.default.useState(null);
    const handlerCheck = (id, checked) => {
        !isDisable && setSelectedId(checked ? id : undefined);
    };
    (0, react_1.useEffect)(() => {
        if (defaultPublic) {
            setSelectedId(defaultPublic);
            setList(PUBLIC_RADIO_LIST.map(item => {
                return { ...item, checked: item.id === defaultPublic };
            }));
        }
        else {
            setSelectedId('hide');
        }
    }, [defaultPublic]);
    (0, react_1.useEffect)(() => {
        handlerChange(selectedId);
    }, [selectedId]);
    return (react_1.default.createElement(common_1.CheckBox, { isDisable: isDisable, isRadioButton: true, list: list, handlerCheck: handlerCheck }));
});
